import React from 'react';
import './StatsCard.css';

const StatsCard = ({ icon, label, value, unit, color = 'cyan', loading }) => {
  return (
    <div className={`stats-card stats-card-${color}`}>
      <div className="stats-card-icon">{icon}</div>
      <div className="stats-card-content">
        <span className="stats-card-label">{label}</span>
        {loading ? (
          <span className="stats-card-loading">...</span>
        ) : (
          <div className="stats-card-value-row">
            <span className="stats-card-value">{value}</span>
            {unit && <span className="stats-card-unit">{unit}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
